import { EmploymentViewModel, EmploymentViewModelNew } from '@fora-monorepo/employer-my-pages-common/types';
import { HeadCellSortState } from '@foradevelopment/fora-ui';

import { PayrollFormData } from '../../payroll/types';
import type { TableSortId } from '../types';
import {
  sortBoolean,
  sortInactiveOrHasDeviation,
  sortKeyHasParams,
  sortKeyInactive,
  sortKeyNone,
  sortStringBasic,
  sortStringLocale,
} from './comparisonFunctions';

type TableSortState = {
  [key in TableSortId]?: HeadCellSortState;
};

// TODO: REMOVE sortEmploymentListIndicesOld function Manage employments

export const sortEmploymentListIndicesOld = ({
  employmentList,
  sortState,
  indices,
  payrollData,
}: {
  employmentList: EmploymentViewModel[];
  sortState: TableSortState;
  indices?: number[];
  payrollData?: PayrollFormData;
}): number[] => {
  // If indices is not empty, sort filtered employments
  const indicesToSort = indices ?? employmentList.map((_, ind) => ind);

  if (Object.keys(sortState).every(state => !state)) {
    return indicesToSort;
  }

  return indicesToSort.sort((a: number, b: number) => {
    const employmentA = employmentList[a];
    const employmentB = employmentList[b];

    // Default sorting by employeeId
    if (sortState.employeeId) {
      return sortStringBasic(
        employmentA.employee.employeeId,
        employmentB.employee.employeeId,
        sortState.employeeId === HeadCellSortState.Asc
      );
    }
    // Sorting by first name
    if (sortState.firstName) {
      return sortStringLocale(
        employmentA.employee.firstName,
        employmentB.employee.firstName,
        sortState.firstName === HeadCellSortState.Asc
      );
    }
    // Sorting by last name
    if (sortState.lastName) {
      return sortStringLocale(
        employmentA.employee.lastName,
        employmentB.employee.lastName,
        sortState.lastName === HeadCellSortState.Asc
      );
    }
    // Sorting by full name (first name)
    if (sortState.fullName) {
      return sortStringLocale(
        employmentA.employee.firstName,
        employmentB.employee.firstName,
        sortState.fullName === HeadCellSortState.Asc
      );
    }
    // Sorting by markup (Uppmärkning)
    if (sortState.markup && (employmentA.activeMarkup?.fokId || employmentB.activeMarkup?.fokId)) {
      return sortStringLocale(
        employmentA.activeMarkup?.fokId ?? '',
        employmentB.activeMarkup?.fokId ?? '',
        sortState.markup === HeadCellSortState.Asc
      );
    }

    // Sorting by fokParameterChoices / inactive icon column
    if (sortState.inactiveOrFokParameterChoices) {
      return sortInactiveOrHasDeviation(
        employmentA.isInactive ? sortKeyInactive : employmentA.hasFokParameterChoices ? sortKeyHasParams : sortKeyNone,
        employmentB.isInactive ? sortKeyInactive : employmentB.hasFokParameterChoices ? sortKeyHasParams : sortKeyNone,
        sortState.inactiveOrFokParameterChoices === HeadCellSortState.Asc
      );
    }

    // Sorting by has attributablePay (hänförlig lön)
    if (sortState.attributablePay && payrollData) {
      return sortBoolean(
        !!payrollData[employmentA.employee.employeeId]?.attributablePay?.length,
        !!payrollData[employmentB.employee.employeeId]?.attributablePay?.length,
        sortState.attributablePay === HeadCellSortState.Asc
      );
    }

    return 0;
  });
};

export const sortEmploymentListIndices = ({
  employmentList,
  sortState,
  indices,
  payrollData,
}: {
  employmentList: EmploymentViewModelNew[];
  sortState: TableSortState;
  indices?: number[];
  payrollData?: PayrollFormData;
}): number[] => {
  // If indices is not empty, sort filtered employments
  const indicesToSort = indices ?? employmentList.map((_, ind) => ind);

  if (Object.keys(sortState).every(state => !state)) {
    return indicesToSort;
  }

  return indicesToSort.sort((a: number, b: number) => {
    const employmentA = employmentList[a];
    const employmentB = employmentList[b];

    // Default sorting by employeeId
    if (sortState.employeeId) {
      return sortStringBasic(
        employmentA.employee.employeeId,
        employmentB.employee.employeeId,
        sortState.employeeId === HeadCellSortState.Asc
      );
    }
    // Sorting by first name
    if (sortState.firstName) {
      return sortStringLocale(
        employmentA.employee.firstName,
        employmentB.employee.firstName,
        sortState.firstName === HeadCellSortState.Asc
      );
    }
    // Sorting by last name
    if (sortState.lastName) {
      return sortStringLocale(
        employmentA.employee.lastName,
        employmentB.employee.lastName,
        sortState.lastName === HeadCellSortState.Asc
      );
    }
    // Sorting by full name (first name)
    if (sortState.fullName) {
      return sortStringLocale(
        employmentA.employee.firstName,
        employmentB.employee.firstName,
        sortState.fullName === HeadCellSortState.Asc
      );
    }
    // Sorting by markup (Uppmärkning)
    if (sortState.markup && (employmentA.activeMarkup?.fokId || employmentB.activeMarkup?.fokId)) {
      return sortStringLocale(
        employmentA.activeMarkup?.fokId ?? '',
        employmentB.activeMarkup?.fokId ?? '',
        sortState.markup === HeadCellSortState.Asc
      );
    }

    // Sorting by fokParameterChoices / inactive icon column
    if (sortState.inactiveOrFokParameterChoices) {
      return sortInactiveOrHasDeviation(
        employmentA.isInactive ? sortKeyInactive : employmentA.hasFokParameterChoices ? sortKeyHasParams : sortKeyNone,
        employmentB.isInactive ? sortKeyInactive : employmentB.hasFokParameterChoices ? sortKeyHasParams : sortKeyNone,
        sortState.inactiveOrFokParameterChoices === HeadCellSortState.Asc
      );
    }

    // Sorting by has attributablePay (hänförlig lön)
    if (sortState.attributablePay && payrollData) {
      return sortBoolean(
        !!payrollData[employmentA.employee.employeeId]?.attributablePay?.length,
        !!payrollData[employmentB.employee.employeeId]?.attributablePay?.length,
        sortState.attributablePay === HeadCellSortState.Asc
      );
    }

    return 0;
  });
};
